import { render, staticRenderFns } from "./NotifyMobileDialog.vue?vue&type=template&id=aa31724c&scoped=true&"
import script from "./NotifyMobileDialog.vue?vue&type=script&lang=ts&"
export * from "./NotifyMobileDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyMobileDialog.vue?vue&type=style&index=0&id=aa31724c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa31724c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon,VImg,VSpacer})
